import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import React from 'react';

const getRadialGradient = (from, to) =>
    `radial-gradient(100% 185.14% at 100% 100%, ${from} 0%, ${to} 100%)`;

const getRadialGradientStraight = (color) =>
    `radial-gradient(100% 100% at 100% 100%, ${color} 0%, ${color} 100%)`;

export const ButtonWrapper = styled(({color, accentColor, fromColor, toColor, ...rest}) => (
    <Button {...rest} />
))`
    && {
        --switch: calc((var(80) - var(60)) * -100%);
        white-space: nowrap;
        padding: 12px 24px;
        color: hsl(0, 0%, var(--switch));
        border: none;
        min-height: 48px;
        min-width: 155px;
        background: none;
        transition: box-shadow 0.25s ${(p) => p.theme.easing}, margin 0.25s ${(p) => p.theme.easing};
        max-width: 100%;
        &.primary {
            color: ${(p) => p.theme.palette.neutral.charcoal};
            background: ${({color, ...p}) => p.accentColor};
            background: ${({color, ...p}) => getRadialGradient(p.fromColor, p.toColor)};
        }
        &.secondary {
            border: 2px solid;
            border-image: ${({color, ...p}) => getRadialGradient(p.fromColor, p.toColor)} 5;
            border-image-width: 2px;
        }
        &.tertiary {
            padding: 0;
            border-radius: 0;
            min-width: auto;
            min-height: auto;
            background-image: ${({color, ...p}) => getRadialGradient(p.fromColor, p.toColor)};
            background-position: 0% 100%;
            background-repeat: no-repeat;
            background-size: 100% 2px;
            padding-bottom: 2px;
            margin-bottom: -2px;
        }
        .container {
            display: flex;
            justify-content: left;
            align-items: center;
            flex-wrap: wrap;
        }
        .arrow-left {
            margin-right: 8px;
            transition: transform 0.2s ${(p) => p.theme.easing};
        }
        .arrow-right {
            margin-left: 8px;
            transition: transform 0.2s ${(p) => p.theme.easing};
        }
        .arrow {
            font-size: 14px;
        }
        .icon {
            color: ${({color, ...p}) => p.accentColor};
            display: unset;
            height: 24px;
        }
        &:hover {
            box-shadow: 0 0 18px ${({color, ...p}) => p.accentColor};
            background-color: transparent;
            &.primary {
                background: ${({color, ...p}) => getRadialGradientStraight(p.accentColor)};
            }
            &.secondary {
                border-color: ${({color, ...p}) => p.accentColor};
                border-image: ${({color, ...p}) => getRadialGradientStraight(p.accentColor)} 5;
            }
            &.tertiary {
                box-shadow: none;
                animation: underline 1.8s infinite;
                @media (prefers-reduced-motion: reduce) {
                    animation: none;
                    background-size: 100% 2px;
                }
                @keyframes underline {
                    0% {
                        background-size: 10% 2px;
                    }
                    50% {
                        background-size: 100% 2px;
                    }
                    100% {
                        background-size: 100% 2px;
                    }
                }
            }
            .arrow-left {
                transform: translateX(-4px);
            }
            .arrow-right {
                transform: translateX(4px);
            }
        }

        &.twinmotion {
            border-radius: 100;
            transition: background 0.25s ${(p) => p.theme.easing},
                border-color 0.25s ${(p) => p.theme.easing};
            &.primary {
                background: ${(p) =>
                    p.theme.ifLight(p, 'theme.palette.common.black', 'theme.palette.common.white')};
                color: ${(p) =>
                    p.theme.ifLight(p, 'theme.palette.common.white', 'theme.palette.common.black')};
            }
            &.secondary {
                border-image: none;
            }
            &:hover {
                box-shadow: none;
                &.primary {
                    background: ${({color, ...p}) => p.accentColor};
                }
                &.secondary {
                    border-image: none;
                }
            }
        }
    }
`;
